"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const react_redux_1 = require("react-redux");
const newsFeedSlice_1 = require("../../../../redux/slices/newsFeedSlice");
const common_1 = require("../../../../utils/common");
const comment_1 = __importDefault(require("../comment/comment"));
const moment_1 = __importDefault(require("moment"));
const svgIcons_1 = require("../../../../svgIcons");
require("./feedView.scss");
require("./../feedItem/feedItem.scss");
class FeedView extends react_1.Component {
    constructor() {
        super(...arguments);
        this.addCommentRef = react_1.createRef();
    }
    render() {
        const { detailsModalOpen, itemNews } = this.props.newsFeed;
        const { source, description, title, link } = itemNews.content;
        const { commentsCount, votes, comments, news_date } = itemNews;
        const submitComment = (e) => {
            const textarea = document.getElementById('message-text-input');
            const txt = textarea.value;
            if (((e.key === 'Enter' && !e.shiftKey) || (e.type === 'click' || e.type === 'touchend')) && /\S/.test(txt)) {
                e.preventDefault();
                e.stopPropagation();
                this.props.addComment({
                    comment: txt.replace(/^\s+|\s+$/g, ''),
                    news_id: itemNews.id,
                    from: 'modal'
                });
                textarea.value = '';
            }
        };
        const onKeyPress = (e) => {
            if (!common_1.isMobileBrowser().check) {
                if (common_1.ifMobile()) {
                    return this.addCommentRef.current.style.height = common_1.isIphoneX() ? 'calc(100% - 5px)' : 'calc(100% - 25px)';
                }
            }
            if (!common_1.ifMobile() && !common_1.isMobileBrowser().check) {
                submitComment(e);
            }
        };
        const makeVote = () => {
            const vote = itemNews.me_voted ? 0 : 1;
            this.props.addVote({
                vote,
                news_id: itemNews.id
            });
        };
        return (title &&
            react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(core_1.Dialog, { className: "single-feed-modal", open: detailsModalOpen, fullWidth: true, maxWidth: 'sm', onClose: () => {
                        this.props.toggleModal();
                        this.props.resetNewsItem();
                    } },
                    react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(core_1.DialogTitle, { className: "modal-header" },
                            react_1.default.createElement(core_1.IconButton, { "aria-label": "close", onClick: () => {
                                    this.props.toggleModal();
                                    this.props.resetNewsItem();
                                } },
                                react_1.default.createElement(Close_1.default, { className: 'modal-close-icon' }))),
                        react_1.default.createElement(core_1.DialogContent, { className: "modal-body" },
                            react_1.default.createElement("div", { className: 'feed-item feed-item-news-modal' },
                                react_1.default.createElement("div", { className: 'news-info' },
                                    react_1.default.createElement("div", { className: 'vote' },
                                        react_1.default.createElement("div", { className: `vote-btn ${itemNews.me_voted ? 'voted' : ''}`, onClick: makeVote },
                                            react_1.default.createElement("div", { className: 'arrow-up' }),
                                            react_1.default.createElement("div", { className: 'vote-count' }, votes || 0)),
                                        react_1.default.createElement("span", { className: `upvote-txt ${itemNews.me_voted ? 'upvoted' : ''}` },
                                            "Upvote",
                                            itemNews.me_voted ? 'd' : '')),
                                    react_1.default.createElement("div", { className: 'news-content' },
                                        react_1.default.createElement("span", { onClick: () => common_1.goExternalUrl(link) }, source),
                                        react_1.default.createElement("h6", { className: 'title' }, title),
                                        react_1.default.createElement("p", { className: 'news-description' }, description),
                                        react_1.default.createElement("p", { className: 'news-date' }, moment_1.default(news_date).format('MMM DD, YYYY').toUpperCase()))),
                                react_1.default.createElement("hr", { className: 'line' }),
                                react_1.default.createElement("div", { className: 'news-comment' },
                                    react_1.default.createElement("span", { className: 'icon-comment' }),
                                    react_1.default.createElement("span", null, commentsCount > 0 ? `Comments ${commentsCount}` : "Comment")),
                                react_1.default.createElement("div", { className: 'add-comment message-field-wrapper' },
                                    react_1.default.createElement(core_1.TextField, { className: 'message-field', size: 'medium', id: 'message-text-input', multiline: true, rows: 1, rowsMax: 3, onKeyPress: (e) => onKeyPress(e), placeholder: 'Type your comment here', variant: "outlined", InputProps: {
                                            endAdornment: react_1.default.createElement(core_1.Box, { className: 'icons-wrapper' },
                                                react_1.default.createElement("div", { className: "send-message-icon", onClick: (e) => submitComment(e), onTouchEnd: (e) => submitComment(e) },
                                                    react_1.default.createElement(svgIcons_1.SendMessageIcon, { style: {
                                                            fontSize: '13px',
                                                            fill: '#AFAFB8'
                                                        } })))
                                        } })),
                                react_1.default.createElement("div", { className: 'comments' }, comments.map((val) => react_1.default.createElement(comment_1.default, { newsId: itemNews.id, comment: val, key: val.id })))))))));
    }
}
const mapStateToProps = (state) => {
    const { newsFeed } = state;
    return {
        newsFeed
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleNewsFeedModal: () => dispatch(newsFeedSlice_1.toggleNewsFeedModal()),
        resetNewsItem: () => dispatch(newsFeedSlice_1.resetNewsItem()),
        addVote: (data) => dispatch(newsFeedSlice_1.addVote(data)),
        addComment: (data) => dispatch(newsFeedSlice_1.addComment(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(FeedView);
